import Flickity from 'flickity';

export default {
  init($element) {

  },
  finalize($element) {
    if ($element.find('.projects-carousel').length > 0) {
      const projectsCarousel = new Flickity($element.find('.projects-carousel').get()[0], {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        groupCells: 1,
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize'));
          },
        },
      });
      
      projectsCarousel.next();

      projectsCarousel.on('change', function() {
        if (projectsCarousel.selectedIndex > 1) {
          $element.find('.carousel-nav-prev').removeClass('hide');
        } else {
          $element.find('.carousel-nav-prev').addClass('hide');
        }

        var twoPerSlide = window.outerWidth >= 992;

        if (projectsCarousel.selectedIndex >= projectsCarousel.slides.length - (twoPerSlide ? 2 : 1)) {
          $element.find('.carousel-nav-next').addClass('hide');
        } else {
          $element.find('.carousel-nav-next').removeClass('hide');
        }

        if (twoPerSlide) {
          if (projectsCarousel.selectedIndex == 0) {
            projectsCarousel.next();
          }

          if (projectsCarousel.selectedIndex == projectsCarousel.slides.length - 1) {
            projectsCarousel.previous();
          }
        }
      });

      $element.find('.carousel-nav-prev').on('click', function() {
        projectsCarousel.previous();
      });

      $element.find('.carousel-nav-next').on('click', function() {
        projectsCarousel.next();
      });

    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/home/projectsCarousel.js